<template>
  <div :key="index" class="card-box">
    <div class="card-limit" v-if="item.isCountDown">
      <timer :ids="item.showTimeEnd" :ids1="item.showTimeStart"></timer>
    </div>
    <div class="card-title">
      <span style="max-width: 220px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;">{{ item.priceProject }}</span>
      <img  v-if="item.rechargeType == 2" style="line-height: 25px;float: right;margin-right: -12px;" src="@/assets/images/image.png" alt="">
    </div>
    <div class="card-content">
      <div class="card-price">
        <div><span class="price-label">价格：</span><span class="price-value">￥{{ item.money }}</span></div>
        <div v-if="showDate"><span class="price-label">周期：</span><span class="price-value">{{ item.cycle }}天</span></div>
      </div>
      <div class="card-button">
        <el-button @click="handleDetail" class="button-box buttonStyle" round style="margin-right: 20px;">服务详情</el-button>
        <el-button @click="handlePay" class="button-box" type="primary" round>立即订购</el-button>
      </div>
    </div>
    <detailDialog v-if="detailVisible"  :content="item.remark" @close="detailVisible = false"></detailDialog>
    <payDialog v-if="payVisible"  :item="item" @close="payVisible = false"></payDialog>
    <tipDialog v-if="tipVisible" @close="tipVisible = false" :item="item" @confirm="tipVisible = false;payVisible = true"></tipDialog>
  </div>
</template>

<script>
import timer from "./changetime.vue";
import payDialog from "./payDialog.vue";
import detailDialog from "./detailDialog.vue";
import tipDialog from "./tipDialog.vue";


export default {
  name: '' ,
  components: {
    timer,
    payDialog,
    detailDialog,
    tipDialog
  },
  props:{
    item:{
      default:()=>{
        return {
          priceProject:'3天高级版升级服务',
          showTimeEnd:'2023-12-31',
          showTimeStart:'2023-12-12',
          money:'￥1000.00',
          cycle:'3day'
        }
      }
    },
    showDate:{
      type:Boolean,
      default:true,
    },

  },
  data() {
    return {
      payVisible:false,
      payObj:{},
      detailVisible:false,
      tipVisible:false,
    }
  },
  computed: {},
  created() {

  },
  mounted() {

  },
  computed: {
    invalidateDate() {
      var invalidateDate = this.$store.getters.loginUserInfo.standardInvalidateDate;
        if (invalidateDate) {
          invalidateDate = invalidateDate.substr(0, 10);
        }
        return invalidateDate;
    },
    daysSoft() {
      var str = 0;
      var invalidateDate = this.invalidateDate;
      if (invalidateDate) {
        str = this.daysBetween(invalidateDate, this.getTodayYMD()) - 1;
      }
      return Number(str);
    },
  },
  methods: {
    handleDetail(){
      this.detailVisible = true;
    },
    handlePay(){
      if(!this.item.buyNum){
        this.$message.warning(
          `当前充值包仅限购${this.item.restrictBuy}次，您已购买${this.item.restrictBuy}次，请选择其他充值包吧！`
        )
      }else{
        if(this.item.cycle > this.daysSoft){
          this.tipVisible = true;
          return
        }
        this.payVisible = true;
      }
      
    },
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf("-") + 1);
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf("-") + 1);
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha = (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) - Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) / 86400000;
      return cha < 0 ? 1 : Math.abs(cha);
    },
    
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var month = month < 10 ? "0" + month : month;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },
  }
}
</script>
<style lang='scss' scoped>
.card-box{
  width: 308px;
  margin: 30px 30px 20px 0;
  padding: 12px;
  position: relative;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #EEEEEE;
  bottom: 0px;
  transition: all 0.3s;
}
.card-limit{
  position: absolute;
  width: 290px;
  height: 28px;
  top: -28px;
  left: 9px;
}

.card-title{
  padding-top: 4px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #AEB3F1;
  color: #333;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
}
.card-content{
  padding-top: 12px;
  padding-bottom: 4px;
  .card-price{
    line-height: 22px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    .price-label{
      font-size: 14px;
      color: #333333;
    }
    .price-value{
      font-size: 16px;
      color: #FE4D45;
    }
  }
  .card-button{
    text-align: center;
    .button-box{
      width: 120px;
      height: 32px;
    }
    .buttonStyle {
      background: #ffffff;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      &:hover {
        background: #fe4d45;
        color: #fff;
      }
    }
  }
}


.card-box:hover{
  bottom: 10px;
  box-shadow: 0px 4px 12px 1px rgba(0,0,0,0.16);
  border: 1px solid #FE8F8A;
}
</style>